import { Base } from './base';

export class Login extends Base {
    username?: string;
    email?: string;
    password?: string;
    key?: string;
}
